var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "File Lockup / * Elements / FIle Format / MOV - Large") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File-Lockup-/-*-Elements-/-FIle-Format-/-MOV---Large",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2C6674",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 1.71428571
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,2.85714286 C17.0494606,2.85714286 21.1428571,6.95053943 21.1428571,12 C21.1428571,17.0494606 17.0494606,21.1428571 12,21.1428571 C6.95053943,21.1428571 2.85714286,17.0494606 2.85714286,12 C2.85714286,6.95053943 6.95053943,2.85714286 12,2.85714286 Z M12,4.57142857 C7.89731329,4.57142857 4.57142857,7.89731329 4.57142857,12 C4.57142857,16.1026867 7.89731329,19.4285714 12,19.4285714 C16.1026867,19.4285714 19.4285714,16.1026867 19.4285714,12 C19.4285714,7.89731329 16.1026867,4.57142857 12,4.57142857 Z",
    id: "Oval-Copy-2",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.4285714,12 C15.4285714,11.76 15.2928571,11.5611429 15.1,11.4377143 L15.1071429,11.424 L10.8214286,8.68114286 L10.8142857,8.69485714 C10.7071429,8.62628571 10.5785714,8.57142857 10.4285714,8.57142857 C10.0357143,8.57142857 9.71428571,8.88 9.71428571,9.25714286 L9.71428571,14.7428571 C9.71428571,15.12 10.0357143,15.4285714 10.4285714,15.4285714 C10.5785714,15.4285714 10.7071429,15.3737143 10.8142857,15.3051429 L10.8214286,15.3188571 L15.1071429,12.576 L15.1,12.5622857 C15.2928571,12.4388571 15.4285714,12.24 15.4285714,12 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.97b19e8c4a6243b7cce45f9a26731c08.svg";
export { ForwardRef as ReactComponent };